import React from 'react';

import { GroupMembers } from '../GroupMembers';
import { IPropsPrivateGroupSettingsDisplay } from './PrivateGroupSettingsPanel';

export const SettingGroupMembers: React.FC<
	IPropsPrivateGroupSettingsDisplay
> = ({ chat, popDisplayState, loadChatChannel }) => {
	return <GroupMembers chat={chat} loadChatChannel={loadChatChannel} />;
};
